export default "__VITE_ASSET__DREIJDeO__"